import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen } from 'lucide-react';
import axios from 'axios';

const API = (() => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'smt-services17.fr' || host === 'www.smt-services17.fr' || host.endsWith('.emergent.host')) {
      return `${window.location.origin}/api`;
    }
  }
  return `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
})();

const formatDate = (iso) => {
  try { return new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }); }
  catch { return iso; }
};

const LatestArticles = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog/featured`)
      .then((res) => setPosts(res.data))
      .catch(() => setPosts([]));
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="conseils" className="section-padding bg-slate-50" data-testid="latest-articles-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-[hsl(32,95%,55%)] font-semibold text-sm uppercase tracking-wider mb-4">
            <BookOpen className="w-4 h-4" />
            Nos derniers conseils
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Le <span className="text-gradient">blog</span> SMT Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Astuces et guides pratiques pour entretenir votre maison et prolonger la vie de vos biens.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-10">
          {posts.map((post, i) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              data-testid={`latest-article-${post.slug}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 border border-slate-100 animate-fade-in-up"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
                <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-5 sm:p-6">
                <p className="text-xs text-slate-400 font-medium mb-2">{formatDate(post.published_at)}</p>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-2 leading-snug line-clamp-2 group-hover:text-[hsl(207,90%,54%)] transition-colors">
                  {post.title}
                </h3>
                <p className="text-sm text-slate-600 line-clamp-2 leading-relaxed mb-3">{post.excerpt}</p>
                <p className="text-xs font-semibold text-[hsl(207,90%,54%)] inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                  Lire <ArrowRight className="w-3.5 h-3.5" />
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/blog"
            data-testid="all-articles-button"
            className="inline-flex items-center gap-2 bg-white hover:bg-slate-100 text-slate-900 border-2 border-slate-200 font-semibold px-8 py-4 rounded-full transition-colors"
          >
            Voir tous nos articles <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestArticles;
